import { ReactNode } from 'react';
import { MdRemoveCircleOutline } from 'react-icons/md';
import { Input } from '../../../../LegacyV4Components';

import {
  CustomerIntegrationsContextData,
  CustomerIntegrationsProvider,
} from '../../../../../hooks/customerIntegrations';

import { TieAccountsModal } from '../TieAccountsModal';

import { unbounce as options } from '../platforms';

import * as Edit from '../components/IntegrationEditRow/styles';
import * as Summary from '../components/IntegrationSummaryRow/styles';

interface ActiveCampaignModalProps {
  show: boolean;
  onClose: () => void;
}

const unbounceRegex = /^[0-9a-fA-F]{8}(-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}$/;

function testRegex(integrationId: string): boolean {
  return unbounceRegex.test(integrationId);
}

export function ConfigUnbounceModal({
  show,
  onClose,
}: ActiveCampaignModalProps) {
  const tableColumns = [
    {
      accessor: 'customer',
      label: 'Cliente',
      sizing: 1,
      sortable: true,
    },
    {
      accessor: 'integrationId',
      label: 'ID da landing page',
      sizing: 1,
      sortable: true,
    },
    {
      accessor: 'status',
      label: 'Status',
      sizing: 0.5,
      sortable: false,
    },
  ];

  function isConnected(integration: AdsAccounts): boolean {
    return (
      unbounceRegex.test(integration.integrationId) &&
      !!integration.projectId &&
      !integration.isDeleted
    );
  }

  function additionalValidation(integration: AdsAccounts): boolean {
    return isConnected(integration);
  }

  function renderEditRow(
    integration: AdsAccounts,
    error: boolean,
    context: CustomerIntegrationsContextData,
  ): ReactNode {
    const { setIntegrationId, deleteIntegration } = context;
    const idError = error && !testRegex(integration.integrationId);
    return (
      <Edit.Row title={integration.integrationId}>
        <div>
          <Input
            label=""
            value={integration.integrationId}
            name="integrationId"
            onChange={({ target: { value } }) =>
              setIntegrationId(integration, value)
            }
            placeholder="2cb5db98-6152-4f37-a5d5-5cd895c0e0e4"
            className={idError ? 'error' : ''}
            mask="********-****-****-****-************"
          />
          {idError && <Edit.Error>ID inválido</Edit.Error>}
        </div>
        <MdRemoveCircleOutline
          size={22}
          onClick={() => deleteIntegration(integration)}
        />
      </Edit.Row>
    );
  }

  function renderSummaryRow(integration: AdsAccounts): ReactNode {
    return (
      <td title={integration.integrationId}>
        <Summary.IntegrationParagraph>
          {integration.integrationId}
        </Summary.IntegrationParagraph>
      </td>
    );
  }

  return (
    <CustomerIntegrationsProvider type={options.type} show={show}>
      <TieAccountsModal
        options={options}
        show={show}
        onClose={onClose}
        tableColumns={tableColumns}
        renderEditRow={renderEditRow}
        renderSummaryRow={renderSummaryRow}
        isConnected={isConnected}
        additionalValidation={additionalValidation}
      />
    </CustomerIntegrationsProvider>
  );
}
